'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deconstructionValue = exports.getStrNotNull = exports.LICENSE_REG = undefined;

var _lodash = require('lodash');

var REGEXP = /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领]{1})([A-Z]?)(.*)$/;
var LICENSE_REG = exports.LICENSE_REG = /(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF])|([DF][A-HJ-NP-Z0-9][0-9]{4}))$)|(^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$)/;

var getStrNotNull = exports.getStrNotNull = function getStrNotNull(next, prev) {
  return !(0, _lodash.isNil)(next) ? next : prev || '';
};

var deconstructionValue = exports.deconstructionValue = function deconstructionValue(value) {
  if (typeof value == 'string') {
    value = value.toUpperCase();
  }
  var group = value && value.match(REGEXP);
  if (group && group.length > 0) {
    return {
      province: group[1],
      city: group[2],
      value: group[3]
    };
  } else {
    return {
      province: '',
      city: '',
      value: value
    };
  }
};